import React from "react";
import { ReactController } from "../react_controller";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PaginatedNameBadgePrimerGrid } from "../../components/grids/NameBadgeGrid/PaginatedNameBadgePrimerGrid";

const queryClient = new QueryClient();

export class NameBadgePrimerGridController extends ReactController {
  connect() {
    this.root.render(
      <QueryClientProvider client={queryClient}>
        <PaginatedNameBadgePrimerGrid {...this.propsValue} />
      </QueryClientProvider>
    );
  }
} 